<template>
	<div class="not-access-to-admin">
		<h1 class="not-access-to-admin__title">Авторизация успешна</h1>

		<p class="not-access-to-admin__description">
			Вы авторизованы под аккаунтом
			<a-tag color="purple">{{ username }}</a-tag>
		</p>

		<br />
		<br />

		<a-button class="not-access-to-admin__logout-button" type="primary" @click="onLogout()">Выйти</a-button>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
	name: "PanelNotAccessToAdmin",

	computed: {
		...mapGetters("User", ["username"])
	},

	async mounted() {
		await this.refreshUser()
	},

	methods: {
		...mapActions("User", ["logout", "refreshUser"]),

		async onLogout() {
			try {
				await this.logout()

				this.$router.replace({ name: "AuthIndex" }).catch()
			} catch (message) {
				this.$alert.error(message)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.not-access-to-admin {
	padding: 40px;

	&__title {
		margin-bottom: 25px;
	}

	&__description {
		font-size: 16px;
	}
}
</style>
